import FileUploadIcon from "@mui/icons-material/FileUpload";
import { Box, Button } from "@mui/material";
import { ChangeEvent } from "react";

interface Props {
    file?: File;
    onChange: (file: File) => void;
}

export default function FileUpload({ file, onChange }: Props) {
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files == null || e.target.files.length == 0) {
            return;
        }
        onChange(e.target.files[0]);
    };

    return (
        <Button variant={"outlined"} component={"label"} fullWidth>
            <Box
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"center"}
                alignItems={"center"}
                width={"100%"}
                py={3}
            >
                <FileUploadIcon />
                {file == undefined ? "Upload File" : file.name}
                <input
                    type={"file"}
                    onChange={handleChange}
                    accept={"image/*"}
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        opacity: 0,
                        cursor: "pointer",
                    }}
                />
            </Box>
        </Button>
    );
}
